module.exports = __webpack_public_path__ + "assets/pizza_active-e8ab26.svg";